var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.format)?[_c('formatter',{attrs:{"text":_vm.$t(_vm.label.text)},scopedSlots:_vm._u([_vm._l((_vm.label.arguments),function(link,slot){return {key:slot,fn:function(s){return [_c('a',{attrs:{"href":link,"target":"_blank"}},[_vm._v(_vm._s(s.text))])]}}})],null,true)})]:[_vm._v(_vm._s(_vm.$t(_vm.label)))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }